import { assertTrue } from "./assert";
/**
 * t=0 => a
 * t=1 => b
 */
export function lerp(a, b, t) {
    return a + (b - a) * t;
}
/**
 * value=start1 => start2
 * value=stop1 => stop2
 */
export function remap({ value, start1, stop1, start2, stop2, }) {
    const position = (value - start1) / (stop1 - start1);
    return lerp(start2, stop2, position);
}
export function constrain({ min, max, value, }) {
    assertTrue(min < max, `min < max: ${min} < ${max}`);
    return Math.max(min, Math.min(max, value));
}
export function compare(as, bs) {
    assertTrue(as.length === bs.length, `${as.length} !== ${bs.length}`);
    for (let i = 0; i < as.length; i += 1) {
        if (as[i] < bs[i]) {
            return "lt";
        }
        else if (as[i] > bs[i]) {
            return "gt";
        }
    }
    return "eq";
}
//# sourceMappingURL=math.js.map